// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5040e249","453":"c264a99b","455":"c64d580a","977":"25f68878"}[chunkId] + ".chunk.js";
};